<!--
  @file BadgedIcon.vue
  @description Reusable icon with a numeric badge positioned at the top-right.
-->
<template>
  <div class="relative inline-block" v-bind="$attrs">
    <i :class="icon" aria-hidden="true"></i>
    <span
      v-if="value > 0"
      class="absolute -top-2 -right-3 rounded-full text-white text-[10px] leading-none flex items-center justify-center min-w-[1rem] h-[1rem] px-[0.5px]"
      :class="badgeBackgroundColor"
    >
      {{ value }}
    </span>
  </div>

</template>

<script setup>
/**
 * Component name for devtools and error traces.
 */
defineOptions({ name: 'BadgedIcon' });

/**
 * Props definition.
 *
 * @property {string} icon - Icon class string applied to the inner <i> tag (e.g., 'pi pi-bell' or 'pi-bell').
 * @property {number} [value=0] - Number shown inside the badge. Badge is hidden when value is 0.
 * @property {string} [badgeBackgroundColor='bg-red-500'] - Tailwind class controlling the badge background color.
 */
defineProps({
  icon: {
    type: String,
    required: true,
  },
  value: {
    type: Number,
    default: 0,
  },
  badgeBackgroundColor: {
    type: String,
    default: 'bg-red-500',
  },
});
</script>

<!--
  Styling is intentionally minimal; Tailwind utility classes handle layout and colors.
-->
<style scoped>
</style>


